import { useThemeSlice } from "../ui/StatusBadge.jsx";

export function SkeletonBlock({ width = "100%", height = 16, radius, style }) {
  const { c, chrome } = useThemeSlice();
  return (
    <div
      className="nemo-skeleton-cell"
      style={{
        width,
        height,
        borderRadius: radius ?? chrome.radiusSm,
        background: c.hover,
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
